import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import { codegen, parse } from 'vega-expression';
import { stringValue } from 'vega-util';
import { globalWholeWordRegExp, keys } from '../util';
/**
 * A class that wraps an expression with a list signal names in the expression. If they are renamed during parsing multi-views,   we can rename then signals in the assemble phase.
 */

export var SignalRefComponent =
/*#__PURE__*/
function () {
  function SignalRefComponent(expr, signalNames) {
    _classCallCheck(this, SignalRefComponent);

    this.expr = expr;
    this.signalNames = signalNames;
  }

  _createClass(SignalRefComponent, [{
    key: "map",

    /**
     * Generate new signal based on this signal
     */
    value: function map(f) {
      return new SignalRefComponent(f(this.expr), this.signalNames);
    }
  }], [{
    key: "fromName",
    value: function fromName(signalName) {
      return new SignalRefComponent(signalName, [signalName]);
    }
  }]);

  return SignalRefComponent;
}();
var generate = codegen({
  globalvar: 'global'
});
export function evalOrMakeSignalRefComponent(expr, params) {
  var varNames = keys(params);
  var signalNames = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = varNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var varName = _step.value;
      var param = params[varName];

      if (param instanceof SignalRefComponent) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = param.signalNames[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var name = _step2.value;
            signalNames.push(name);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        expr = expr.replace(globalWholeWordRegExp(varName), param.expr);
      } else {
        // primitive value
        expr = expr.replace(globalWholeWordRegExp(varName), stringValue(param));
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (signalNames.length > 0) {
    return new SignalRefComponent(expr, signalNames);
  } else {
    try {
      // Try to evaluate the expression and return the value if we succeed.
      var ast = parse(expr);

      var _generate = generate(ast),
          code = _generate.code;

      var f = new Function('global', "return ".concat(code, ";")); // tslint:disable-line:function-constructor

      return f(params);
    } catch (error) {
      if (error.message.indexOf('Unrecognized function') === 0) {
        // This expression contains a function that needs to be evaluated at runtime, so let's keep it as a SignalRefComponent.
        return new SignalRefComponent(expr, []);
      }

      throw error;
    }
  }
}